import React, {Component} from 'react';
import {
  Button,
  Modal,
  List,
  Spin,
  Empty,
  Icon,
  Col,
  Row
} from 'antd';
import axios from 'axios';
import { Constant } from "../../../config";
import InfiniteScroll from 'react-infinite-scroller';
import Moment from 'react-moment';
import '../PriceManagement.css';

class ChangeLogs extends Component {

  state = {
    logs: [],
    loading: true,
    gatewayId: null,
    totalLogs: 0,
    logsPage: 1,
    hasMoreLogs: true,
    countryList: []
  };

  componentWillMount() {
    const { gatewayId, countryList } = this.props
    this.setState({
      gatewayId,
      countryList
    })
  }

  async componentDidMount() {
    const changeLogs = await this._fetchVendorChangeLogs();
    this.setState({
      loading: false,
      logs: changeLogs.logs,
      gatewayName: changeLogs.name,
      totalLogs: changeLogs.total
    });
  }

  _fetchVendorChangeLogs = async (page = 1, limit = 5, filter = {order_by: 'id', order: 'asc'}) => {
    const url = `${Constant.COST_PRICE_CHANGE_LOGS_API.replace("[id]", this.state.gatewayId)}`;
    for (const key in filter) {
      if (!filter[key]) {
        delete filter[key];
      }
    }
    const options = {
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
      params: {
        page,
        limit,
        ...filter,
      },
    };
    let resp;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    let logs = {};

    if (resp.data) {
      logs = resp.data;
    }

    return logs;
  };

  _handleInfiniteOnLoad = async () => {
    let { logs } = this.state

    this.setState({ loading: true });
    if (logs.length === this.state.totalLogs) {
      this.setState({
        hasMoreLogs: false,
        loading: false,
      });
      return;
    }

    let { logsPage } = this.state
    logsPage++
    this.setState({
      logsPage
    });
    
    const changeLogs = await this._fetchVendorChangeLogs(logsPage);
    logs = logs.concat(changeLogs.logs)

    this.setState({
      loading: false,
      logs
    });
  };

  actionType = (type, gatewayIdBefore, countryAbbr) => {
    let actionType = '';

    switch (type) {
      case 'create':
        actionType = 'Add Cost'
        break;
      case 'update':
        actionType = 'Edit Price: '
        break;
      case 'set_active_gateway':
        if (gatewayIdBefore === 0) {
          actionType = 'Set Active Vendor: '
        } else {
          if (countryAbbr === 'NONE') {
            actionType = 'Change Default Vendor'
          } else {
            actionType = 'Change Active Vendor: '
          }
        }
        break;
      default:
        actionType = '-'
        break;
    }
    return actionType
  }

  findCountryName = (regionCode) => {
    if (!regionCode || regionCode === 'NONE') return
    const country = this.state.countryList.find((c) => {
      return c.region_code === regionCode.toUpperCase();
    })
    return  country.name || '-';
  }

	render() {
    const { onCancel, visible } = this.props;

		return (
			<Modal
        className="my-layout"
        footer={
          <div style={{textAlign: 'center'}}>
            <Button key="cancel" onClick={onCancel}>
              Close
            </Button>
          </div>
        }
        onCancel={onCancel}
        title={
          <div>{this.state.gatewayName} <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>Change Logs</span></div>
        }
        visible={visible}
      >
        <div className="change-logs-container">
          <InfiniteScroll
              initialLoad={false}
              pageStart={0}
              loadMore={this._handleInfiniteOnLoad}
              hasMore={!this.state.loading && this.state.hasMoreLogs}
              useWindow={false}
            >
            <List>
              {this.state.logs.map((log, index) => (
                <List.Item key={`logs-${index + 1}`}>
                  <div className='change-logs-detail'>
                    <div className='logs-header'>
                      <span><Moment unix tz="Etc/UTC" format="DD/MM/YYYY HH:mm">{log.created_date}</Moment></span>&nbsp;-&nbsp;
                      <span>{this.actionType(log.event, log.gateway_id_before, log.country_abbr)}</span><span>{(log.event === 'update' || log.event === 'set_active_gateway') && this.findCountryName(log.country_abbr)}</span>
                    </div>
                    <div className='logs-body'>
                      {log.event === 'create' && (
                        <Row type="flex" justify="center" gutter={10}>
                          <Col span={10} style={{textAlign: 'right'}}>{this.findCountryName(log.country_abbr)}</Col>
                          <Col span={4} style={{textAlign: 'center'}}><Icon type="arrow-right" /></Col>
                          <Col span={10}>{Number.parseFloat(log.price_after).toFixed(4)}</Col>
                        </Row>
                      )}
                      {log.event === 'update' && (
                        <Row type="flex" justify="center" gutter={10}>
                          <Col span={10} style={{textAlign: 'right', color: 'rgba(0, 0, 0, 0.45)'}}>{Number.parseFloat(log.price_before).toFixed(4)}</Col>
                          <Col span={4} style={{textAlign: 'center'}}><Icon type="arrow-right" /></Col>
                          <Col span={10}>{Number.parseFloat(log.price_after).toFixed(4)}</Col>
                        </Row>
                      )}
                      {log.event === 'set_active_gateway' && log.gateway_id_before > 0 && (
                          <Row type="flex" justify="center" gutter={10}>
                          <Col span={10} style={{textAlign: 'right'}}>{log.gateway_name_before}</Col>
                          <Col span={4} style={{textAlign: 'center'}}><Icon type="arrow-right" /></Col>
                          <Col span={10}>{log.gateway_name}</Col>
                        </Row>
                      )}
                      {log.event === 'set_active_gateway' && log.gateway_id_before === 0 && (
                        <Row type="flex">
                          <Col span={24} style={{textAlign: 'center'}}>{log.gateway_name}</Col>
                        </Row>
                      )}
                      {log.note && <p className='logs-note'><span>Note:</span> {log.note}</p>}
                    </div>
                  </div>
                </List.Item>
              ))}
              {this.state.logs.length === 0 && (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
              {this.state.loading && this.state.hasMoreLogs && (
                <div className="logs-loading">
                  <Spin />
                </div>
              )}
            </List>
          </InfiniteScroll>
        </div>
        {(this.state.logs.length > 0 && this.state.logs.length !== this.state.totalLogs) && (
          <div className='logs-scroll'>
            Scroll for more
          </div>
        )}
      </Modal>
		)
	}
}

export default ChangeLogs


// WEBPACK FOOTER //
// ./src/containers/PriceManagement/Modals/ChangeLogs.js